import { useGRPCMutation } from "@/utils/hooks/grpc/use-grpc-mutation";
import { createCustomerIncident } from "@/gen_src/proto/chalk/server/v1/support-SupportService_connectquery";
import {
  createPagerDutyIncidentWithModal,
  CreatePagerDutyIncidentParams,
} from "@/utils/support-utils";
import toast from "react-hot-toast";
import { useCallback } from "react";

export function usePagerDutyEscalation() {
  const { isPending, mutate: createIncident } = useGRPCMutation(createCustomerIncident, {
    onError: (error) => toast.error(`Failed to create incident: ${error.message}`),
    onSuccess: () => toast.success(`Incident has been escalated to the Chalk team.`),
  });

  const escalateIssue = useCallback(
    async (params: Omit<CreatePagerDutyIncidentParams, "additionalDescription">) => {
      const request = await createPagerDutyIncidentWithModal(params);

      if (request) {
        createIncident(request);
      }
    },
    [createIncident],
  );

  return {
    escalateIssue,
    isCreatingIncident: isPending,
  };
}
